import { toast } from "react-hot-toast";
import axios from "axios";


const instance = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    }
});

const getApiErrorMessage = (payload, fallback = "Something went wrong") => {
    if (!payload) {
        return fallback;
    }

    if (typeof payload === "string") {
        return payload;
    }

    if (Array.isArray(payload)) {
        const [firstMessage] = payload;
        return typeof firstMessage === "string" && firstMessage.trim()
            ? firstMessage
            : fallback;
    }

    if (typeof payload !== "object") {
        return fallback;
    }

    if (Array.isArray(payload.message)) {
        return payload.message.join("\n");
    }

    if (typeof payload.message === "string" && payload.message.trim()) {
        return payload.message;
    }

    if (typeof payload.error === "string" && payload.error.trim()) {
        return payload.error;
    }

    const fieldError = Object.entries(payload).find(([key, value]) => {
        if (["message", "error", "status", "code", "detail"].includes(key)) {
            return false;
        }

        return Array.isArray(value) && value.some((item) => typeof item === "string" && item.trim());
    });

    if (fieldError) {
        const [, value] = fieldError;
        return value.find((item) => typeof item === "string" && item.trim()) || fallback;
    }

    return fallback;
};


instance.interceptors.request.use(function (config) {
    if (localStorage.getItem("access_token") !== '' && localStorage.getItem("access_token") !== null) {
        config.headers['Authorization'] = 'Bearer ' + localStorage.getItem("access_token");
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});


instance.interceptors.response.use(function (response) {
    if ((response?.config?.method !== "get" && response?.data?.message)) {
        toast.success(response?.data?.message, { id: 'toast', duration: 5000, position: 'top-center' })
    } if (response?.data?.error === true) {
        toast.error(
            <div style={{
                whiteSpace: "pre-line",
                textAlign: "left",
                maxHeight: "300px",
                overflowY: "auto",
                overflowX: "hidden",
                paddingRight: "8px"
            }}>
                {getApiErrorMessage(response?.data)}
            </div>,
            {
                id: 'toast',
                duration: 5000,
                position: 'top-center'
            }
        );
    }
    return response;
}, function (error) {
    if (error?.response?.status === 401) {
        localStorage.clear();
        toast.error('Session expired. Please log in again.', { id: 'toast', duration: 4000, position: 'top-center' });
        setTimeout(() => {
            window.location.href = '/login';
        }, 1500); // 1.5s delay so the user can read the toast before redirect
        return Promise.reject(error);
    }
    if (error.response?.config?.method !== "get") {
        toast.error(
            <div style={{
                whiteSpace: "pre-line",
                textAlign: "left",
                maxHeight: "300px",
                overflowY: "auto",
                overflowX: "hidden",
                paddingRight: "8px"
            }}>
                {getApiErrorMessage(error?.response?.data)}
            </div>,
            {
                id: 'toast',
                duration: 5000,
                position: 'top-center'
            }
        );
    }

    return Promise.reject(error);
});

export default instance
